import mainStyle from "../mainStyle.module.scss";

import React from "react";
import { useTheme } from "@mui/material/styles";
import { Tooltip } from "@mui/material";
import icn_expand_right from "assets/images/icons/icn_expandright.svg";
import { ReactComponent as ProIcon } from "assets/images/icons/icn-pro.svg";
import { ReactComponent as ProOrangeOutlineIcon } from "assets/images/icons/icn_Pro_orange_outline.svg";
import useZustandStore from "zustandStore";

const SubMenu = ({ nowAnchor, item, setNowAnchor, ipAddressProfileCount, ldapProfileCount }) => {
  const theme = useTheme();
  const isUnityProSubscribed = useZustandStore(
    (state) => state.serviceStatus?.services?.unityPro === true
  );

  const proLicensePages = ['profiles-ip-address', 'profiles-ldap-server'];
  const supportProIcon = proLicensePages.includes(item.key);

  return (
    <div key={item.key}>
      <div
        className={mainStyle["subAnchorItem"]}
        style={{
          backgroundColor:
            nowAnchor === item.key
              ? theme.palette.primary.subBlue
              : "",
        }}
        onClick={() => setNowAnchor(item.key)}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <span
              style={{
                width: "6px",
                height: "6px",
                backgroundColor: theme.palette.primary.main,
                margin: "2.5px 10px 2.5px 0",
                borderRadius: "2px",
                display: "inline-block",
              }}
            />
            <span
              className={mainStyle["subAnchorItem_text"]}
              style={{ color: theme.palette.primary.main }}
            >
              {item.label}
            </span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {supportProIcon && (
              item.key === "profiles-ip-address" && !isUnityProSubscribed
                ? ipAddressProfileCount !== null && (
                  ipAddressProfileCount === 0
                    ? <ProIcon />
                    : (
                      <Tooltip title="Pro feature disabled" arrow>
                        <ProOrangeOutlineIcon />
                      </Tooltip>
                    )
                )
                : item.key === "profiles-ldap-server" && !isUnityProSubscribed
                  ? ldapProfileCount !== null && (
                    ldapProfileCount === 0 ? <ProIcon /> : (
                      <Tooltip title="Pro feature disabled" arrow>
                        <ProOrangeOutlineIcon />
                      </Tooltip>
                    )
                  )
                  : <ProIcon />
            )}

            {item.showArrow && <img src={icn_expand_right} alt='' />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubMenu;
